// leadingSpeakerLen returns the character length of the leading speaker reference
// in a bullet's text — the pronoun "You"/"They"/"Them" or the owner's first name
// at the very start — so a consumer can tint just that span in the speaker's
// transcript color. Returns 0 when the bullet doesn't open with a speaker (most
// context facts), so nothing is tinted.
export const leadingSpeakerLen = (text: string, owner?: string): number => {
  const match = /^[A-Za-z']+/.exec(text);
  if (!match) return 0;
  const word = match[0];
  // Drop any contraction ("They'll" -> "they") so only the pronoun is tinted.
  const bare = word.toLowerCase().replace(/'.*$/, "");
  if (bare === "you" || bare === "they" || bare === "them") return bare.length;
  const ownerFirst = owner?.trim().split(/\s+/)[0]?.toLowerCase();
  if (ownerFirst && bare === ownerFirst) return word.length;
  return 0;
};
